// toggl-timer-button.component.ts
import { ChangeDetectorRef, Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import * as moment from 'moment';
import { TogglService } from '../toggl.service';

@Component({
    selector: 'toggl-timer-button',
    templateUrl: './toggl-timer-button.component.html',
    styleUrls: ['./toggl-timer-button.component.scss'],
})
export class TogglTimerButtonComponent implements OnInit, OnDestroy {
    @Input() jobId!: number;
    @Input() showInfo = true;
    @Input() showTimer = true;
    @Input() size: 'small'|'large' = 'small';

    isRunning = false;
    private timerStartedAt: moment.Moment|null = null;
    private sub = new Subscription();

    constructor(
        private togglService: TogglService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit() {
        this.sub.add(
            this.togglService.togglRunningJob$.subscribe(r => {
                const shouldBeRunning = !!r && r.jobId === this.jobId;
                this.isRunning = shouldBeRunning;
                if (shouldBeRunning && r) {
                    this.timerStartedAt = moment(r.startTime);
                } else {
                    this.timerStartedAt = null;
                }
                // Trigger change detection to update the UI
                this.cd.detectChanges();
            })
        );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    start() {
        this.isRunning = true;
        this.timerStartedAt = moment();
        this.cd.detectChanges();

        this.togglService.startTimerForJob(this.jobId).subscribe({
            error: err => {
                console.error('startTimer failed', err);
                this.isRunning = false;
                this.timerStartedAt = null;
                this.cd.detectChanges();
            }
        });
    }

    stop() {
        this.isRunning = false;
        this.timerStartedAt = null;
        this.cd.detectChanges();

        this.togglService.stopTimer().subscribe({
            error: err => {
                console.error('stopTimer failed', err);
                this.isRunning = true;
                this.timerStartedAt = moment();
                this.cd.detectChanges();
            }
        });
    }

    runningTimerDuration(): string {
        if (!this.timerStartedAt) return '00:00:00';
        const d = moment.duration(moment().diff(this.timerStartedAt));
        return [ d.hours(), d.minutes(), d.seconds() ]
            .map(v => v.toString().padStart(2,'0'))
            .join(':');
    }
}
